import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { AmountToPay } from 'account/amount-to-pay/amount-to-pay';
import { AmountToPayLayout } from 'account/amount-to-pay/amount-to-pay.store';
import { Button } from 'components/buttons/button';
import { ButtonType } from 'components/buttons/button-types';
import { FeatureFlag } from 'core/enums/feature-flag';
import { Util } from 'utils/common.utils';
import { PopupStore } from '../popup.store';
import styles from '../popup.module.scss';

export const PaymentReminderPopUp = observer<{ popupStore: PopupStore }>(({ popupStore }) => {
  const { t } = useTranslation();
  const earnableValue = 500;
  const earnableBonus = 1500;

  const desc = t('dashboard.paymentReminder', {
    viewingDays: `${popupStore.viewingDaysLeft}`,
    earnableValue,
  });

  const descTimely = t('dashboard.paymentReminderTimely', {
    viewingDays: `${popupStore.viewingDaysLeft}`,
    earnableValue,
    earnableBonus,
  });

  const descToUse = popupStore.isDebitOrder ? desc : descTimely;

  const sectionName = `${popupStore.isDebitOrder ? 'Debit Order' : 'Cash'} payment reminder_${descToUse}`;

  return (
    <div className="d-flex flex-column align-items-center cust-g-2">
      <img className={styles.paymentReminderImage} src={Util.GetImageAsset('rewards/coin.svg')} />
      <div className={'text-large text-bold'}>{t('account.amountToPay.paymentReminder')}</div>
      <div className={'text-center'}>{descToUse}</div>
      <div className="d-flex justify-content-center cust-g-2">
        {!popupStore.isDebitOrder && (
          <AmountToPay
            layout={AmountToPayLayout.Button}
            analyticsEntryPoint="DisM payment reminder"
            customAreaName={sectionName}
            customJourneyName={FeatureFlag.DashboardPaymentReminderAnnouncement}
          />
        )}
        <Button
          meta={{
            type: ButtonType.OutlineDark,
            title: t('buttons.close'),
            analyticsTargetUrl: Util.CurrentLocation(),
            areaName: sectionName,
          }}
          onClick={() => popupStore.changeIsOpen(false)}
          analyticsComponentName="paymentReminderModel"
          analyticsAdditionalProps={{
            buttonCta: t('buttons.close'),
          }}
        />
      </div>
    </div>
  );
});